<template>
	<div class="info">
		<div class="layout">

			<div v-if="hasExpiredSubscription" class="expiring-alert expired">
				⚠️ Il tuo abbonamento è scaduto! Contattaci per rinnovarlo.
			</div>
			<div v-else-if="hasExpiringSubscription" class="expiring-alert">
				⚠️ Il tuo abbonamento sta per scadere! Contattaci per rinnovarlo.
			</div>

			<div class="profile-card">
				<div class="container">
					<div class="image pad-l">
						<img :src="user.picture_url" />

						<svg class="foreground" viewBox="0 0 160 160" width="100%" height="100%" fill="transparent">
							<circle
								r="52" cx="80" cy="80"
								stroke-dasharray="314"/>
						</svg>
						<svg class="background" viewBox="0 0 160 160" width="100%" height="100%" fill="transparent">
							<circle
								r="58" cx="80" cy="80"
								stroke-dasharray="314"/>
						</svg>
					</div>

					<div class="pad-l">
						<div class="name">{{ user.first_name + ' ' + user.last_name }}</div>
						<div class="email">
							<span class="icon-md t-middle">email</span>
							<span class="d-inlineblock w-xs"></span>
							<span class="t-middle">{{ user.email }}</span>
						</div>
						<br>
						<div class="profile-upload">
							<input ref="fileInput" type="file" @change="onFileSelected" accept="image/*" style="display: none;" />
							<button class="button-yellow" @click="$refs.fileInput.click()">Cambia immagine</button>
							<br>
							<button
								v-if="user.picture_url"
								class="button-yellow remove"
								style="margin-top: 1.2em;"
								@click="removeProfileImage"
							>
								Rimuovi immagine profilo
							</button>
						
							<div v-if="previewUrl" class="crop-area">
								<div class="crop-container" ref="cropContainer">
									<img
										draggable="false"
										@mousedown.prevent
										@dragstart.prevent
										:src="previewUrl"
										ref="cropImage"
										class="crop-image"
										:style="{
											width: '320px',
											userSelect: 'none',
											cursor: isDragging ? 'grabbing' : 'grab',
											transform: `translate(${offsetX}px, ${offsetY}px)`
										}"
										@mousedown="startDrag"
										@mousemove="onDrag"
										@mouseup="endDrag"
										@mouseleave="endDrag"

										@touchstart="startTouch"
										@touchmove="onTouchMove"
										@touchend="endTouch"
									/>
								</div>
								<div v-if="isMobile" class="arrow-controls">
									<button @click="move('up')">⬆️</button>
									<div class="horizontal-arrows">
										<button @click="move('left')">⬅️</button>
										<button @click="move('right')">➡️</button>
									</div>
									<button @click="move('down')">⬇️</button>
								</div>
								<div class="crop-buttons">
									<button class="button-yellow" @click="confirmCropCanvas">Conferma ritaglio e Carica</button>
									<button class="button-yellow" @click="clearPreview">Annulla</button>
								</div>
							</div>
						</div>

						<!--  <div v-if="user.membership"><b>Eximus Online Training: ON</b></div>-->
						<br>
						<a href="../first-access" style="color: #ffe010;">Cambia Password</a>
					</div>
				</div>
			</div>
		<!--<div class="prom_cont" id="once">
				<div class="prom">
					<h2>Avviso per tutti i nostri atleti!  &#127947;</h2>
					<p><b>A partire da Lunedì 5 Febbraio le classi di Lunedì e Giovedì delle 18.15 verranno anticipate alle 18.00</b></p>
					<div class="button" @click="chiudi()"><button>X</button></div>
				</div>
			</div>
		<div class="profile-card">
				<div class="container">
					<div class="links">
						<ul>
							<li><img :src="require('@/assets/gdrive.svg')"/><a href="https://drive.google.com/open?id=1nqXqlDgWACKEjNcMFCFBYD637o9edVzq" target="_blank">Libreria Video</a></li>
							<li><a href="#">Blog (in arrivo!)</a></li>
						</ul>
						<iframe src="https://drive.google.com/embeddedfolderview?id=18zxQp7TsHzn6p4gK9I_5B0e7EsYPtOn9#grid" width="100%" height="500" frameborder="0">
						</iframe>
					</div>

								<div class="library" v-if="user.membership">
									<div v-for="videoid in videos" :key="videoid"
										class="video">
										<div class="frame">
											<iframe class="player" :src="'http://www.youtube.com/embed/' + videoid" frameborder="0"></iframe>
										</div>
									</div>
								</div>

					<router-link v-if="user.membership" class="online-gym" :to="{name: 'eximus-online-training'}">Accedi ai tuoi allenamenti online</router-link>
				</div>
			</div>

			<div class="profile-card">
				<div class="container">
					<div class="links2">
						<ul>
							<li style="font-size:1.4em;"><img :src="require('@/assets/sanvalentino2.jpg')"/><br><b>Porta il tuo partner o un amico/a non iscritto e vi allenate gratis tutta la settimana!</b><br>(Offerta valida dal 13 al 19 Febbraio).</li>
						</ul>
					</div>
				</div>
			</div>-->
			<!-- COMUNICAZIONE -->
			
			<div class="highlight-card">
			<p><strong>⚠️ A partire da lunedì 30 giugno, le nostre Small Class passeranno da 6 a 8 posti disponibili.</strong></p>
<p style="margin-top:1em;">
Putroppo in un periodo in cui tutto aumenta di prezzo abbiamo provato a contrastare fino alle fine l’aumento dei prezzi ma sta diventando difficile anche per noi la gestione.<br><br>

Per non gravare sulle vostre tasche come succede ovunque abbiamo deciso di non aumentare le tariffe, ma di ampliare leggermente il numero di partecipanti per classe in modo da poter garantire la solita qualità dei servizi senza dover fare tagli.<br><br>

È una decisione che abbiamo preso con grande attenzione, perché la qualità del nostro lavoro e l’esperienza di chi si allena con noi vengono prima di tutto.
Grazie alla professionalità del nostro team e all’organizzazione delle lezioni, la qualità delle Small Class resterà alta come sempre, così come l’attenzione e la cura per ogni persona.<br><br>

Grazie per la fiducia e per far parte della famiglia Eximus.</p>
			</div>

			<!-- SEZIONE PROMO AMICO -->
			
			<div class="highlight-card">
			<h2>Chi porta un amico trova un tesoro! 👫</h2>
			<p>Porta un amico a provare e al momento dell'iscrizione riceverai 2 lezioni in omaggio! 💪</p>
			</div>

			<!-- SEZIONE DOPPIA: pacchetti + novità -->
			<div class="dual-grid">
			<!-- PACCHETTI ATTIVI (layout invariato) -->
			<div class="products" v-if="products && products.length">
				<h2>Pacchetti attivi</h2>

				<div class="products-grid">
				<div v-for="prod in products" :key="prod.id" 
					class="product" 
					:class="productClasses(prod)">
					<div class="info">
					<div class="name">
						<div>{{ prod.name }}</div>
						<div v-if="prod.size === 0 && isExpired(prod.expire_date)" class="badge badge-expired">Scaduto</div>
						<div v-else-if="prod.size === 0 && isExpiring(prod.expire_date)" class="badge">In Scadenza</div>
					</div>
					<div class="charges">
						<div v-if="prod.size > 0" class="remaining">{{ prod.remaining || '-' }}</div>
						<div v-if="prod.size > 0" class="size">/{{ prod.size }}</div>
						<div v-if="prod.size === 0 && prod.expire_date" class="expiration">
						Scade il {{ formatDate(prod.expire_date) }}
						</div>
					</div>
					</div>
				</div>
				</div>

				<div class="links2">
				<div class="resub">
					<a href="./shop#class"><button class="buttonresub">Rinnova qui il tuo pacchetto online!</button></a>
				</div>
				</div>
			</div>

			<!-- SEZIONE NOVITÀ -->
			<div class="novita">
				<h2>Novità</h2>
				<ul>
				<li>
					<span class="emoji">🏃‍♂️</span>
					<strong>Analisi biomeccanica della corsa</strong> (-20% per i clienti Eximus!): scopri come migliorare la tua tecnica e prevenire infortuni!
					<button><a href="/analisi-corsa">Info</a></button>
				</li>
				<li>
					<span class="emoji">🏀⚽🏐</span>
					<strong>Eximus Off-Season</strong>: il martedi e giovedì dalle 19.30.
				</li>
			<!--<li>
					<span class="emoji">🎽</span>
					<strong>Trofeo Sempione</strong>: Domenica 15 Giugno corri con noi a Milano!
				</li>-->
				</ul>
			</div>
			</div>

			<!-- LEZIONI COMPLETATE 
			<div class="highlight-card" v-if="completedThisYear > 0">
			<p>🔥 Ti sei allenato <strong>{{ completedThisYear }}</strong> volte dall'inizio dell'anno, continua così!</p>
			</div> -->

		</div>
	</div>
</template>

<script>
import ShowMore from '@/components/global/ShowMore'
import md5 from 'blueimp-md5'
import Cropper from 'cropperjs'
import '@/assets/css/cropper.css'


export default {
	name: 'info',
	beforeMount() {
		window.addEventListener("load", this.onWindowLoad);
	},

	components: {
		ShowMore
	},
	data() {
		return {
			selectedFile: null,
			previewUrl: null,
			cloudinaryPreviewUrl: null,
			imagePreviewUrl: null,
			offsetX: 0,
			offsetY: 0,
			scale: 1,
			baseScale: 1, // <- nuova
			isDragging: false,
			dragStartX: 0,
			dragStartY: 0,
			startOffsetX: 0,
			startOffsetY: 0,
			isMobile: false
		}
	},
	mounted() {
		this._cropperInstance = null;
		this.isMobile = /Mobi|Android/i.test(navigator.userAgent);
	},
	props: {
		/// User data
		user: {
			type: Object,
			required: true
		},

		/// User products
		products: {
			type: Array,
			default: () => []
		},

		/// Videos
		videos: {
			type: Array,
			required: false
		}
	},

	computed: {
		/**
		 * Active subscription
		 */
		sub() {

			return this.user.subscriptions[0]
		},

		hasExpiringSubscription() {
			if (!this.products) return false;
			return this.products.some(prod => prod.size === 0 && this.isExpiring(prod.expire_date));
		},

		hasExpiredSubscription() {
			if (!this.products) return false;
			return this.products.some(prod =>
				prod.size === 0 && this.isExpired(prod.expire_date)
			);
		}
	},
	methods: {
		move(direction) {
			const step = 5;
			const maxOffset = 20;
			const minOffset = -(320 - 300) - 20;

			if (direction === 'up') {
				this.offsetY = Math.max(minOffset, this.offsetY - step);
			} else if (direction === 'down') {
				this.offsetY = Math.min(maxOffset, this.offsetY + step);
			} else if (direction === 'left') {
				this.offsetX = Math.max(minOffset, this.offsetX - step);
			} else if (direction === 'right') {
				this.offsetX = Math.min(maxOffset, this.offsetX + step);
			}
		},
		startTouch(e) {
			this.isDragging = true;
			const touch = e.touches[0];
			this.dragStartX = touch.clientX;
			this.dragStartY = touch.clientY;
			this.startOffsetX = this.offsetX;
			this.startOffsetY = this.offsetY;
		},

		onTouchMove(e) {
			e.preventDefault(); // <-- aggiungi questa riga
			if (!this.isDragging) return;
			const touch = e.touches[0];

			const dx = touch.clientX - this.dragStartX;
			const dy = touch.clientY - this.dragStartY;

			const newOffsetX = this.startOffsetX + dx;
			const newOffsetY = this.startOffsetY + dy;

			// Limiti
			const maxOffset = 20;
			const minOffset = -(320 - 300) - 20; // = -40

			this.offsetX = Math.max(minOffset, Math.min(maxOffset, newOffsetX));
			this.offsetY = Math.max(minOffset, Math.min(maxOffset, newOffsetY));
		},

		endTouch() {
			this.isDragging = false;
		},
		startDrag(e) {
			this.isDragging = true;
			this.dragStartX = e.clientX;
			this.dragStartY = e.clientY;
			this.startOffsetX = this.offsetX;
			this.startOffsetY = this.offsetY;
		},
		onDrag(e) {
			if (!this.isDragging) return;

			const dx = e.clientX - this.dragStartX;
			const dy = e.clientY - this.dragStartY;

			const newOffsetX = this.startOffsetX + dx;
			const newOffsetY = this.startOffsetY + dy;

			// Limiti
			const maxOffset = 20;
			const minOffset = -(320 - 300) - 20; // = -40

			// Applica limiti
			this.offsetX = Math.max(minOffset, Math.min(maxOffset, newOffsetX));
			this.offsetY = Math.max(minOffset, Math.min(maxOffset, newOffsetY));
		},
		endDrag() {
			this.isDragging = false;
		},
		onWheel(e) {
			const delta = e.deltaY > 0 ? -0.05 : 0.05;
			this.scale = Math.min(Math.max(this.scale + delta, 0.1), 5);
		},
		async confirmCropCanvas() {
			const canvasSize = 300;
			const canvas = document.createElement('canvas');
			canvas.width = canvasSize;
			canvas.height = canvasSize;
			const ctx = canvas.getContext('2d');

			ctx.clearRect(0, 0, canvasSize, canvasSize);
			ctx.beginPath();
			ctx.arc(canvasSize / 2, canvasSize / 2, canvasSize / 2, 0, Math.PI * 2);
			ctx.closePath();
			ctx.clip();

			const img = new Image();
			img.crossOrigin = 'anonymous';
			img.src = this.previewUrl;

			await new Promise(resolve => img.onload = resolve);

			// L'immagine è renderizzata a 300px di larghezza, calcola proporzione
			const naturalWidth = img.naturalWidth;
			const naturalHeight = img.naturalHeight;
			const scale = 320 / naturalWidth;

			const scaledHeight = naturalHeight * scale;

			// Trasformiamo offset (in px visivi) in coordinate reali dell'immagine
			const sx = -this.offsetX / scale;
			const sy = -this.offsetY / scale;
			const sw = canvasSize / scale;
			const sh = canvasSize / scale;

			console.log({ sx, sy, sw, sh });

			ctx.drawImage(img, sx, sy, sw, sh, 0, 0, canvasSize, canvasSize);

			const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg'));
			const formData = new FormData();
			formData.append('file', blob, 'cropped.jpg');
			formData.append('upload_preset', 'eximus_profile');

			try {
				const res = await fetch('https://api.cloudinary.com/v1_1/damcnnhm2/image/upload', {
				method: 'POST',
				body: formData,
				});
				const data = await res.json();

				const session = JSON.parse(localStorage.getItem('session'));
				const token = session ? session.access_token : null;
				const apiURL = process.env.NODE_ENV === 'production'
				? 'https://eximus.herokuapp.com/api/v1'
				: 'http://localhost:5000/api/v1';

				await fetch(`${apiURL}/u/update-picture`, {
				method: 'POST',
				headers: {
					'Authorization': 'Bearer ' + token,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ picture_url: data.secure_url })
				});

				// Dopo l'update su /update-picture...
				const resSession = await fetch(`${apiURL}/u/me`, {
				headers: {
					'Authorization': 'Bearer ' + token
				}
				});

				const updatedUser = await resSession.json();
				const updatedSession = {
				...session,
				user: updatedUser
				};

				localStorage.setItem("session", JSON.stringify(updatedSession));
				window.location.reload(); // forza il refresh anche della header ecc.
			} catch (err) {
				console.error(err);
				alert("Errore nel caricamento.");
			}
		},
		confirmCrop() {
			this.uploadImage();
		},
		clearPreview() {
			this.selectedFile = null;
			this.previewUrl = null;
			this.cloudinaryPreviewUrl = null;

			if (this._cropperInstance && typeof this._cropperInstance.destroy === 'function') {
				try {
					this._cropperInstance.destroy();
				} catch (e) {
					console.warn("Errore durante destroy cropper:", e);
				}
			}
			this._cropperInstance = null;


			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = null;
			}
		},
		async onFileSelected(event) {
			const file = event.target.files[0];
			if (!file || !file.type.startsWith('image/')) return;

			const maxSizeMB = 5;
			if (file.size > maxSizeMB * 1024 * 1024) {
				alert('Il file è troppo grande. Massimo 5MB.');
				return;
			}

			this.previewUrl = URL.createObjectURL(file);
			this.selectedFile = file;
			this.offsetX = 0;
			this.offsetY = 0;

			await this.$nextTick();

			const image = this.$refs.cropImage;
			if (image) {
				image.draggable = false;
				image.addEventListener('dragstart', e => e.preventDefault());
			}
		},
		async removeProfileImage() {
			try {
				const session = JSON.parse(localStorage.getItem('session'));
				const token = session && session.access_token;

				if (!token) {
					alert("Devi effettuare il login.");
					return;
				}

				const email = session.user && session.user.email ? session.user.email.trim().toLowerCase() : '';
				const gravatarHash = md5(email);
				const fallbackUrl = `https://www.gravatar.com/avatar/${gravatarHash}?d=retro&s=196`;
				
				await fetch(`${process.env.NODE_ENV === 'production' ? 'https://eximus.herokuapp.com' : 'http://localhost:5000'}/api/v1/u/update-picture`, {
					method: 'POST',
					headers: {
						'Authorization': 'Bearer ' + token,
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ picture_url: fallbackUrl })
				});

				const apiURL = process.env.NODE_ENV === 'production'
				? 'https://eximus.herokuapp.com/api/v1'
				: 'http://localhost:5000/api/v1';

				// Dopo l'update su /update-picture...
				const resSession = await fetch(`${apiURL}/u/me`, {
				headers: {
					'Authorization': 'Bearer ' + token
				}
				});

				const updatedUser = await resSession.json();
				const updatedSession = {
				...session,
				user: updatedUser
				};

				localStorage.setItem("session", JSON.stringify(updatedSession));
				window.location.reload(); // forza il refresh anche della header ecc.
			} catch (err) {
				console.error('Errore durante la rimozione della foto:', err);
				alert('Errore. Non è stato possibile rimuovere la foto.');
			}
		},
		formatDate(dateStr) {
			if (!dateStr) return '';
			const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
			return new Date(dateStr).toLocaleDateString('it-IT', options);
		},

		productClasses(prod) {
			if (prod.size === 0) {
				// È un abbonamento
				const isExpired = this.isExpired(prod.expire_date)
				return {
					subscription: true,
					expiring: this.isExpiring(prod.expire_date),
					expiredSub: isExpired
				};
			} else {
				// È un pacchetto normale
				return {
					expired: prod.remaining <= 0
				};
			}
		},
		
		isExpiring(expirationDate) {
			if (!expirationDate) return false;
			const today = new Date();
			const expDate = new Date(expirationDate);
			const diffTime = expDate - today;
			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			return diffDays <= 7;
		},

		isExpired(expirationDate) {
			if (!expirationDate) return false;
			const today = new Date().setHours(0, 0, 0, 0);
			const exp = new Date(expirationDate).setHours(0, 0, 0, 0);
			return exp <= today;
		},

		onWindowLoad(){
			var testo = document.getElementById("once");
			const promotion = window.localStorage.getItem("hide_promotion2");

			if(promotion === "b"){
				testo.style.display = "none";
			}else {
				testo.style.display = "block";
				window.localStorage.setItem("hide_promotion2", "b");
			}
		},

		chiudi(){
			var prom = document.getElementById("once");
			prom.style.display = "none";
		}
	}
}
</script>

<style lang="stylus" scoped>
.info2
	padding 1em 1.5em

	background repeating-linear-gradient(45deg, rgba(dark, 0), rgba(dark, 0) 1.6em, rgba(dark, 0.5) 1.6em, rgba(dark, 0.5) 3.2em)

	font-family fontSans

.info .layout
	max-width 1280px
	margin 0 auto

	display grid
	grid-template-columns auto
	grid-gap 1em

.links
	ul
		list-style-type none
		
		li
			display flex
			align-items center

			margin 1em auto
			border-radius: 2em
			transition 0.15s ease

			img
				width 2em
				height 2em
				display block

				background light
				border-radius 30px
				padding 0.4em

				transition transform 0.25s ease

				.promosan
					width 100%
					height 3em
		
			a
				font-size 1.4em
				text-decoration none
				color #dcdcdc
				cursor pointer
				padding 0.25em
				border-radius 5px
				margin-left 0.2em
				margin-right 0.2em
				transition 0.15s ease

			&:hover

				img
					transform: rotate(120deg)
				a

.links2
	ul
		list-style-type none
		
		li
			align-items center

			margin 1em auto
			border-radius: 2em
			transition 0.15s ease

			img
				height 4em
				display block
				padding 0.4em

			a
				font-size 1.4em
				text-decoration none
				color #dcdcdc
				cursor pointer
				padding 0.25em

.profile-card
	padding 1em
	border-radius 1em

	background-color dark

	.container
		.library
			display grid
			grid-template-columns repeat(3, 1fr)
			grid-gap 1em

			padding 2em

			.video
				width 100%

				.frame
					width 100%

					position relative
					
					padding-bottom 56.25%

					.player
						width 100%
						height 100%

						position absolute
						z-index 1
		
		.online-gym

			display block

			margin 1em
			padding 0.8em
			border-radius 0.8em
			box-sizing border-box

			background-color secondary
			color light

			font-size 1.2em
			font-weight bold
			text-align center
			text-decoration none

			&:hover
				color lighter

@keyframes spin-foreground
	0%
		transform rotate(66deg)
		stroke-dashoffset 150%
	40%
		transform rotate(359deg)
		stroke-dashoffset 120%
	65%
		transform rotate(-66deg)
		stroke-dashoffset 160%
	100%
		transform rotate(66deg)
		stroke-dashoffset 150%

@keyframes spin-background
	0%
		transform rotate(52deg)
		stroke-dashoffset 150%
	40%
		transform rotate(300deg)
		stroke-dashoffset 50%
	65%
		transform rotate(20deg)
		stroke-dashoffset 160%
	100%
		transform rotate(52deg)
		stroke-dashoffset 150%

.container
	.image
		width 256px
		height 256px

		box-sizing border-box

		position relative

		&>img
			height 100%
			width 100%
			object-fit cover
			object-position center

			position absolute
			top 0
			left 0
			z-index 3

			padding 2em
			border-radius 50%
			box-sizing border-box
		
		&>svg
			width 100%
			height 100%

			position absolute
			top 0
			left 0

			stroke-width 2.2em

			&.foreground
				z-index 2

				stroke primary
				stroke-dashoffset 150%

				transform rotate(66deg)

				animation spin-foreground 4s ease-in-out 0.1s 2 alternate

			&.background
				z-index 1

				stroke secondary
				stroke-dashoffset 150%

				transform rotate(52deg)

				animation spin-background 4.2s ease-in-out 0s 2 alternate

	.name
		margin 0.2em 0

		color lighter

		font-size 3em
		font-weight bold

	.email
		margin 0.2em 0

		font-size 1.4em

.subscription
	margin-top 1em
	padding 2em

	.grid
		display grid
		grid-template-columns repeat(2, 1fr)
		grid-gap 1em

		@media (max-width: unit(media-phone-max, px))
			grid-template-columns 1fr
		
		.field
			.value
				padding 0.4em 0.6em
				border-bottom 1px solid primary

				color lightish

				font-size 1.2em
				font-weight bold
			
			>label
				padding 0.2em

				color primary

				font-size 0.9em

.products
	padding 2em
	border-radius 1em

	background-color dark

	.products-grid
		display grid
		grid-template-columns repeat(3, 1fr)
		grid-gap 1em

		@media screen and (max-width: unit(media-phone-max, px))
			grid-template-columns auto

		.product
			padding 1em
			border 1px solid darkish
			border-radius 0.5em

			.info
				display grid
				grid-template-columns 1fr auto
				align-items center

				.name
					color light
					margin-right 0.5em
					font-size 1.4em
					font-weight bold
				
				.charges
					padding 1em
					border-left 2px solid secondary
					text-align center
					min-height 60px
					display flex
					flex-direction column
					justify-content center
					align-items center

					.remaining
						color secondary

						font-size 2em
						font-weight bold

					.expiration
						margin-top 0.5em
						font-size 0.9em
						color lightish
			
			&.selected
				box-shadow 0 0 0 2px primary

				.name
					color primary
			
		.expired
			border-color crimson
			
			color mix(light, dark, 50%)

			.info
				.name
					color inherit
				
				.charges
					border-left-color crimson

					.remaining
						color crimson

		.expiredSub
			border 2px solid crimson
			color mix(light, dark, 50%)

			.info
				.name
					color inherit

				.charges
					border-left 2px solid crimson

.prom_cont
	z-index 9999
	position fixed
	bottom 0
	width 100%
	left 0
	display none

	.prom
		background #232b34
		font-size 1.2em
		padding 15px
		margin-left 2em
		margin-right 2em
		margin-bottom 1em
		border-radius 1em

		.button
			width 45px
			margin 0 auto

			button
				background #ffe010
				border 0px
				padding 1em
				font-size 0.8em
				border-radius 2em
				width 45px
		h2 
			color #ffe010

.resub
	max-width 100%
	margin-top 2em

.buttonresub
	padding 0.6em 1em
	border-radius 0.6em
	text-align center
	text-decoration none
	font-weight bold
	max-width 600px

	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.1em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.product.subscription
	border 2px solid #00bcd4 // bordo azzurro chiaro
	color light
	.name
		color light
	.charges
		border-left 2px solid #00bcd4

.product.expiring
	border 2px dashed #ffe010
	color light
	.name
		color orange
	.charges
		border-left 2px dashed #ffe010

.expiring-alert
	background-color #ff9800
	color dark
	font-weight bold
	text-align center
	padding 1em
	margin-bottom 1em
	border-radius 1em

.expiring-alert.expired
	background-color crimson
	color light

.badge
	background-color #ffe010
	color dark
	padding 0.2em 0.5em
	margin-top 0.5em
	border-radius 0.5em
	font-size 0.8em
	font-weight bold
	text-align center
	display inline-block

.package-ended
	margin-top 0.5em
	color crimson
	font-weight bold
	font-size 0.9em

.badge-expired
	background-color crimson
	color light
	padding 0.2em 0.5em
	margin-top 0.5em
	border-radius 0.5em
	font-size 0.8em
	font-weight bold
	text-align center
	display inline-block

.promobox-container
	display grid
	grid-template-columns repeat(auto-fit, minmax(300px, 1fr))
	gap 1.5em
	margin 1em 0

.promobox
	background-color #101418
	border-radius 1em
	padding 1.5em
	display flex
	flex-direction column
	justify-content space-between
	color white
	box-shadow 0 0 10px rgba(0,0,0,0.2)

	.icon
		font-size 2em
		margin-bottom 0.5em

	.title
		font-size 1.4em
		font-weight bold
		margin-bottom 0.5em
		line-height 1.4em

	.desc
		font-size 1.3em
		color #ccc
		margin-bottom 1.2em

	.btn-yellow
		background-color #ffe010
		color #111
		padding 0.6em 1em
		border-radius 0.6em
		text-align center
		text-decoration none
		font-weight bold
		font-size 1em
		transition 0.2s ease

.dual-grid
	display: grid
	grid-template-columns: 2fr 1fr
	gap: 1.5em
	margin-top: 0em

	@media screen and (max-width: 768px)
		grid-template-columns: 1fr

.novita
	background-color dark
	padding: 1.5em
	border-radius: 1em
	color: light

	h2
		margin-bottom: 0.5em

	ul
		list-style: none
		padding: 0

	li
		margin: 0.6em 0
		font-size: 1.1em

		button
			background primary
			padding 0.6em
			border-radius 0.6em
			border 0
			margin-left 0.5em

			a
				color dark
				text-decoration: none
				font-weight bold
				font-size 1.1em

.emoji
	margin-right: 0.6em

.highlight-card
	background-color dark
	padding: 1.5em
	margin: 1em 0 1em 0
	border-radius: 1em
	color: light
	font-size: 1.2em

	h2
		font-size: 1.5em
		margin-bottom: 0.4em

	p
		margin: 0

.button-yellow
	padding 0.6em 1em
	border-radius 0.6em
	background-color #ffe010
	color #111
	font-weight bold
	border none
	cursor pointer
	margin-right 0.5em
	transition 0.2s ease

	&:disabled
		background-color #ccc
		color #666
		cursor not-allowed
	
.remove
	font-size 0.7em
	background-color transparent
	color #ffe010
	border none
	padding 0

.preview-img
	margin-top 1em

	img
		width 120px
		height 120px
		border-radius 50%
		object-fit cover
		box-shadow 0 0 8px rgba(255, 255, 255, 0.2)

.cropper-container
	margin-top 1em
	text-align center

.cropper-img
	max-width 100%
	max-height 300px
	border-radius 0.5em
	box-shadow 0 0 8px rgba(255,255,255,0.2)

.crop-buttons
	margin-top 1em

.crop-area {
  text-align: center;
  margin-top: 1em;
}

.crop-container {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  border: 2px solid #ffe010;
  background: #000;
  touch-action: none;
  cursor: grab;
}

.crop-image {
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
  pointer-events: auto;
}
.arrow-controls {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 10px;
	gap: 4px;
}

.horizontal-arrows {
	display: flex;
	gap: 10px;
}

</style>
